var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 22C6.48107 22 2.00391 17.5229 2.00391 12C2.00391 6.47715 6.48107 2 12.0039 2C17.5267 2 22.0039 6.47715 22.0039 12C22.0039 17.5229 17.5267 22 12.0039 22ZM12.0039 20C16.4222 20 20.0039 16.4183 20.0039 12C20.0039 7.58172 16.4222 4 12.0039 4C7.58563 4 4.00391 7.58172 4.00391 12C4.00391 16.4183 7.58563 20 12.0039 20ZM12.0039 7.05025L16.9536 12L12.0039 16.9497L7.05417 12L12.0039 7.05025ZM12.0039 9.87868L9.88259 12L12.0039 14.1213L14.1252 12L12.0039 9.87868Z",
    fill: "url(#paint0_linear_448_35750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7L7 12L12 17V14L10 12L12 10V7Z",
    fill: "url(#paint1_linear_448_35750)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7L17 12L12 17V14L14 12L12 10V7Z",
    fill: "url(#paint2_linear_448_35750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_448_35750",
    x1: 2.00391,
    y1: 12,
    x2: 22.0039,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_448_35750",
    x1: 7,
    y1: 12,
    x2: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_448_35750",
    x1: 17,
    y1: 12,
    x2: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.49478ca4990589dd5cef271bcb0cb364.svg";
export { ForwardRef as ReactComponent };